import { render, staticRenderFns } from "./CreateConsignmentNote.vue?vue&type=template&id=620e03ac&scoped=true&"
import script from "./CreateConsignmentNote.vue?vue&type=script&lang=js&"
export * from "./CreateConsignmentNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620e03ac",
  null
  
)

export default component.exports